import React, { useState, useEffect } from 'react';

type CountdownProps = {
    startTime: string; // Start time in ISO format
    endTime: string;   // End time in ISO format
};

const CountdownTimer: React.FC<CountdownProps> = ({ startTime, endTime }) => {
    const [timeLeft, setTimeLeft] = useState<string>('');

    useEffect(() => {
        // Update the count down every 1 second
        const timer = setInterval(() => {
            const now = new Date().getTime();
            const end = new Date(endTime).getTime();
            const distance = end - now;

            // Time calculations for days, hours, minutes and seconds
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            
            // Output the result in an element with id="demo"
            setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s `);

            // If the count down is over, write some text 
            if (distance < 0) {
                clearInterval(timer);
                setTimeLeft('Ended');
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [endTime]);

    return (
            <span>{timeLeft}</span>
    );
};

export default CountdownTimer;
